export const ACTIONS_WRAPPER_DISPLAY_NAME = 'PageHeaderActions'
